import { observeAddressByPhoneNumber } from "../../../../../database/helpers/address";
import {
  bulkCreateOrdersV3,
  bulkDeleteOrders,
  bulkRestoreStock,
  bulkUpdateOrders,
  bulkUpdateTransactionStock,
  observeOrdersByInvoiceID,
} from "../../../../../database/helpers/orders";
import {
  formattedCount,
  getCategoriesByType,
  resolveCategoryDisplayName,
  removeRsFromValue,
  roundToTwoDecimalPlaces,
  validatePriceQtyInput,
} from "../../../../../utils";
import { LanguageContext } from "../../../../../context/LanguageContext";
import { formatNum } from "../../../../../oscar-pos-core/constants";
import { useAuthContext } from "../../../../../context/AuthContext";
import BusinessLoader from "../../../../common/BusinessLoader";
import { useLocation, useNavigate } from "react-router-dom";
import withObservables from "@nozbe/with-observables";
import { Sync } from "../../../../../SyncService";
import SignatureSection from "./SignatureSection";
import { Fragment, useEffect } from "react";
import React, { useLayoutEffect, useContext, useState, useMemo, useRef } from "react";
import {
  AppCheckbox,
  ParagraphText,
  UBButton,
  UBInput,
  UBRadioBox,
} from "../../../../../Libraries";
import {
  calculateTotalOutstanding,
  findCustomerByID,
  getCustomerByID,
} from "../../../../../database/helpers/customer";
import {
  converTextToImage,
  EMIONBOARDINGSTATUS,
  getSerailNumber,
  sentenceCase,
  updatedPaymentMethods,
  uuid,
  VERIFIED,
} from "../../../../../constants";
import {
  formatDiscount,
  getSignImage,
  getConvertedDisountMehod,
  getPaymentMethodType,
} from "../../invoiceBookUtils";
import {
  bulkStockCreation,
  bulkUpdateStockV2,
} from "../../../../../database/helpers/stock";
import {
  bulkCreateInventoryV3,
  bulkDeleteInventory,
  bulkUpdateInventory,
} from "../../../../../database/helpers/inventory";
import {
  fetchBillInvoicesCount,
  fetchSaleInvoicesCount,
  observeCurrentInvoice,
} from "../../../../../database/helpers/invoice";
import {
  AppCollectPayment,
  NetCalculationCard,
  PaymentMethodToggle,
  RouteLeavingGuard,
  SelectAmountSummary,
  TitleAndActionBox,
} from "../../../../common";
import TabAutoComplete from "../../../../../Libraries/TabAutoComplete";

import { analytics, triggerLogEvent } from "../../../../../config/firebase";
import { Box, capitalize, Chip, Grid } from "@mui/material";
import { useDemoModeNavigation } from "../../../../../hooks/useDemoNavigation";
import "./../../styles.css";
import styles from "./styles.module.css";
import { phoneNumRegex } from "../../../../../validations";
import AddCustomerModal from "../../../../common/Modals/AddCustomerModal";
import { of } from "rxjs";
import StockAddItem from "../../../../common/StockAddItem";
import {
  BankIconNew,
  EnterIcon,
} from "../../../../../assets/icons/icon";
import moment from "moment";
import PreviewInvoice from "./PreviewInvoice";
import UBDateSelect from "../../../../../Libraries/UBDateSelect";
import dayjs from "dayjs";
import { useWalletContext } from "../../../../../context/WalletContext";
import {
  bulkCreatePayments,
  bulkDeletePaymentsV2,
  getPaymentsByInvoiceExternal,
} from "../../../../../database/helpers/payment";
import { useSnackbar } from "../../../../../context/SnackbarContext";
import PaymentQRCode from "../../../../container/SaleExpense/PaymentQRCode";
import { WalletNonidealModal } from "../../../../common/Modals";

const CreateInvoice = ({
  invoiceCount,
  invoice,
  orders,
  invCustomer,
  customers,
}) => {
  const invoiceDetail = invoice ? invoice[0] : invoice;
  const [I18n] = useContext(LanguageContext);
  const { fetchAccountInfo, isAccountLoading, accountInfo } =
    useWalletContext();
  const raastDetail = accountInfo?.raast_info?.raast;

  const isEMIVerified = accountInfo?.emi_onboarding_status == EMIONBOARDINGSTATUS.VERIFIED

  const { business, user } = useAuthContext();
  const location = useLocation();
  let isEditFlow = Boolean(
    invoice?.[0] && location?.pathname?.includes?.("Edit") && location?.state?.data?.invoiceId
  );

  // Snapshot of original edit-flow values — set once when invoice data loads.
  const editSnapshotRef = useRef(null);
  // State (not ref) so setting it triggers a re-render, making isFormDirty=false
  // BEFORE navigate() fires the useBlocker check.
  const [bypassGuard, setBypassGuard] = useState(false);
  // Holds the navigation function to call after the bypass re-render.
  const pendingNavRef = useRef(null);

  useEffect(() => {
    if (!bypassGuard || !pendingNavRef.current) return;
    const fn = pendingNavRef.current;
    pendingNavRef.current = null;
    fn();
  }, [bypassGuard]);

  // Stable serialiser for item list comparison.
  const serializeItems = (items) =>
    [...items]
      .sort((a, b) => String(a.id).localeCompare(String(b.id)))
      .map((i) => `${i.id}:${Number(i.quantity)}:${Number(i.selling_price)}:${Number(i.cost_price)}`)
      .join('|');

  let customerAdded = Boolean(isEditFlow && invCustomer?.[0]);
  let totalInvoices = location?.state?.data?.invoiceCount || invoiceCount || 0;

  let type = location?.pathname?.includes("PurchaseInvoice") ? "out" : "in";
  const navigate = useNavigate();
  const { handleDemoNavigation } = useDemoModeNavigation();

  const [customer, setCustomer] = useState(null);
  const [invoiceNum, setInvoiceNum] = useState({
    prefix: null,
    num: null,
  });
  const [itemObj, setItemObj] = useState({});
  const [ItemList, setItemList] = useState([]);
  const [totalDiscount, setTotalDiscount] = useState({
    edit: false,
    value: null,
    type: null,
  });
  const [totalTax, setTotalTax] = useState({
    edit: false,
    value: null,
  });
  const [businessSign, setBusinessSign] = useState({ type: null, value: null });
  const [startDate, setStartDate] = useState(new Date());
  const [dueDate, setDueDate] = useState(null);
  const [subTotalAmt, setSubTotalAmt] = useState(0);
  const [IsAlreadysubTotalAmt, setIsAlreadySubTotalAmt] = useState(false);
  const [netTotalAmt, setNetTotalAmt] = useState(null);
  const [balanceAmount, setBalanceAmount] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [contactList, setContactList] = useState([]);
  const [createCustomerModal, setCreateCustomerModal] = useState(false);
  const [initName, setInitname] = useState("");
  const [initPhone, setInitphone] = useState("");
  const [addContact, setAddContact] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [walletNonidealModal, setWalletNonidealModal] = useState(false);
  const [open, setOpen] = useState(false);

  const [state, setState] = useState({
    note: "",
    isSignature: false,
    po: "",
    category: "",
    categoryLabel: "",
    status:
      invoiceDetail?.status === "paid"
        ? "Paid"
        : invoiceDetail?.status === "unpaid"
          ? "Unpaid"
          : "Paid",
  });
  const resolvePaymentMethod = (invoice) => {
    if (!invoice) return updatedPaymentMethods.find((m) => m.name === "bank") || null;
    const method = (invoice?.method || "").toLowerCase();
    if (!method) return null;
    return updatedPaymentMethods.find((m) => m.type === method || m.name === method) || null;
  };

  const [pmtMethod, setPmtMethod] = useState(null);
  const [receivedAmt, setReceivedAmt] = useState({
    edit: false,
    value: invoiceDetail?.advance_amount || null,
    paymentMethod: resolvePaymentMethod(invoiceDetail),
  });
  const { showSnackbar } = useSnackbar();

  const [isNextPage, setNextPage] = useState(false);

  // Derive dirty state from actual values in both flows so the guard disappears
  // when the user reverts a change back to its original value.
  const isFormDirty = (() => {
    if (bypassGuard) return false;
    if (isEditFlow) {
      const snap = editSnapshotRef.current;
      if (!snap) return false; // data not loaded yet — don't block navigation
      return (
        (customer?.id || null) !== snap.customerId ||
        (state.note || "") !== snap.note ||
        (state.po || "") !== snap.po ||
        (state.category || "") !== snap.category ||
        state.isSignature !== snap.isSignature ||
        dayjs(startDate).format("DD MMM YYYY") !== snap.startDateDay ||
        (dueDate ? dayjs(dueDate).format("DD MMM YYYY") : null) !== snap.dueDateDay ||
        (Number(totalDiscount.value) || 0) !== snap.discountValue ||
        (totalDiscount.type || "rs") !== snap.discountType ||
        (Number(totalTax.value) || 0) !== snap.taxValue ||
        (Number(receivedAmt.value) || 0) !== snap.receivedAmtValue ||
        (businessSign.value || null) !== snap.signatureValue ||
        (snap.itemsKey !== null && serializeItems(ItemList) !== snap.itemsKey)
      );
    }
    // Create flow: dirty when any meaningful field has been filled in.
    return Boolean(
      customer !== null ||
      ItemList.length > 0 ||
      state.note.trim() ||
      state.po.trim() ||
      state.category ||
      state.isSignature ||
      dueDate !== null ||
      totalDiscount.value ||
      totalTax.value ||
      receivedAmt.value ||
      businessSign.value,
    );
  })();
  const isSale = type === "in";

  const onChangeText = (key, text) => {
    if (key === "note") {
      if (text.length >= 1 && state.note.length == 0 && !isEditFlow)
        triggerLogEvent(
          analytics,
          isSale ? "sale_invoice_note_start" : "purchase_bill_note_start",
          { amount: text },
        );
    }

    setState((preState) => ({
      ...preState,
      [key]: text,
    }));
  };
  useEffect(() => {
    setCategoryList(getCategoriesByType(isSale ? "business_sale" : "business_expense"));
  }, [isSale]);

  useEffect(() => {
    if (!isEditFlow && (location.pathname.includes("InvoiceBook/Edit") || location.pathname.includes("PurchaseInvoice/Edit"))) {
      navigate(location.pathname.includes("InvoiceBook/Edit") ? "/InvoiceBook/Create" : "/PurchaseInvoice/Create", { replace: true })
    }
    if (!accountInfo && user?.phone_number) fetchAccountInfo(navigate);
  }, []);

  useEffect(() => {
    setContactList([
      ...customers.map((item) => {
        return {
          id: item.id,
          labelText: item.name,
          label: (
            <Fragment>
              <span className="newFontColor">{item.name}</span>
              <span className="newLightColor">
                {item?.is_supplier ? "Supplier" : "Customer"}
              </span>
            </Fragment>
          ),
          value: item.name,
          phone_number: item.phone
        };
      }),
    ]);
  }, [customers]);


  useEffect(() => {
    if (isEditFlow) {
      if (invoice && invoice?.[0]) {
        const [cust_inv] = invoice;
        setNetTotalAmt(cust_inv?.amount || cust_inv?.total || "");
        setIsAlreadySubTotalAmt(!!cust_inv?.sub_total);
        setSubTotalAmt(cust_inv?.sub_total);
        setTotalDiscount({
          edit: Boolean(cust_inv?.discount) || false,
          value: cust_inv?.discount || null,
          type: cust_inv?.discount_unit === "%" ? "%" : "rs",
        });
        setTotalTax({
          edit: Boolean(cust_inv?.tax_rate) || false,
          value: cust_inv?.tax_rate || null,
        });
        setReceivedAmt({
          edit: false,
          value: cust_inv?.advance_amount || null,
          paymentMethod: resolvePaymentMethod(cust_inv),
        });
        setBusinessSign({
          type: cust_inv?.signature ? "img" : null,
          value: cust_inv?.signature || null,
        });

        setStartDate(new Date(cust_inv?.transacted_at));
        setDueDate(cust_inv?._raw?.due_date ? new Date(cust_inv?._raw?.due_date) : null);
        setState((e) => ({
          ...e,
          note: cust_inv?.note || "",
          isSignature: Boolean(cust_inv?.signature),
          po: cust_inv?.reference_id,
          category: cust_inv?.category,
          categoryLabel:
            resolveCategoryDisplayName(
              type === "in" ? "business_sale" : "business_expense",
              cust_inv?.category,
            ) || "",
        }));

        // Capture the initial snapshot once so we can detect true dirty state.
        if (!editSnapshotRef.current) {
          // If orders are already available at snapshot time, serialise them
          // immediately to avoid a race where the orders effect runs first.
          const initialOrderItems = (orders || []).map((el) => ({
            id: el.stock.id,
            quantity: el.quantity,
            selling_price: el.selling_price,
            cost_price: el.cost_price,
          }));
          editSnapshotRef.current = {
            customerId: invCustomer?.[0]?.id || null,
            note: cust_inv?.note || "",
            po: cust_inv?.reference_id || "",
            category: cust_inv?.category || "",
            isSignature: Boolean(cust_inv?.signature),
            startDateDay: dayjs(cust_inv?.transacted_at).format("DD MMM YYYY"),
            dueDateDay: cust_inv?._raw?.due_date
              ? dayjs(cust_inv?._raw?.due_date).format("DD MMM YYYY")
              : null,
            discountValue: Number(cust_inv?.discount) || 0,
            discountType: cust_inv?.discount_unit === "%" ? "%" : "rs",
            taxValue: Number(cust_inv?.tax_rate) || 0,
            receivedAmtValue: Number(cust_inv?.advance_amount) || 0,
            signatureValue: cust_inv?.signature || null,
            itemsKey: initialOrderItems.length > 0
              ? serializeItems(initialOrderItems)
              : null,
          };
        }
      }
      if (invCustomer && invCustomer?.[0]) {
        const [cust] = invCustomer;
        setCustomer((c) => ({
          id: cust?.id,
          label: cust?.name,
          labelText: cust?.name,
          value: cust?.name,
          phone_number: cust?.phone
        }));
      }
    }
  }, [invoice, invCustomer]);

  useEffect(() => {
    if (orders?.length > 0) {
      const items = {};
      const itemsArr = [];

      orders.forEach((element) => {
        const obj = {
          cost_price: element.cost_price,
          id: element.stock.id,
          name: element.name,
          quantity: element.quantity,
          selling_price: element.selling_price,
        };
        items[element.stock.id] = obj;
        itemsArr.push(obj);
      });
      setItemObj(items);
      setItemList(itemsArr);
      handleUpdateByItem(itemsArr);

      // Store initial items key for edit-flow dirty detection.
      if (isEditFlow && editSnapshotRef.current && editSnapshotRef.current.itemsKey === null) {
        editSnapshotRef.current.itemsKey = serializeItems(itemsArr);
      }
    }
  }, [orders]);

  const resetState = () => {
    if (totalDiscount.value !== null && totalTax.value !== null) {
      setBalanceAmount(null)
      setTotalDiscount({
        edit: false,
        value: null,
        type: null,
      })
      setTotalTax({
        edit: false,
        value: null,
      })
      setPmtMethod(null)
      setReceivedAmt({
        edit: false,
        value: invoiceDetail?.advance_amount || null,
        paymentMethod: resolvePaymentMethod(invoiceDetail),
      })
      setNetTotalAmt(null)
    }
  }

  useEffect(() => {
    if (subTotalAmt > 0) {
      const discValue = Number(totalDiscount.value) || 0;
      const taxValue = Number(totalTax.value) || 0;
      const discDeduct =
        totalDiscount.type === "%"
          ? subTotalAmt * (discValue / 100)
          : discValue;
      const tot = +(subTotalAmt - discDeduct).toFixed(2);
      const taxAdd = +(tot * (taxValue / 100)).toFixed(2);
      const val = roundToTwoDecimalPlaces(tot + taxAdd);
      setNetTotalAmt(val || null);
    }
    else {
      resetState()
    }
  }, [subTotalAmt, totalDiscount, totalTax]);

  useEffect(() => {
    if (netTotalAmt === null || netTotalAmt === undefined) return;
    const advance = Number(receivedAmt?.value) || 0;
    const total = netTotalAmt - advance;
    if (total >= 0) {
      setBalanceAmount(total);
    } else if (advance > 0) {
      setReceivedAmt((r) => ({ ...r, value: null, paymentMethod: null }));
      setBalanceAmount(netTotalAmt);
      showSnackbar({
        message: I18n.advance_amount_exceeds_total || "Advance payment removed as it exceeds the invoice total",
        severity: "info",
      });
    }
  }, [netTotalAmt, receivedAmt]);

  const updateNetTotalAmt = (subTotalAmt, totalDiscount, totalTax) => {
    let discValue = Number(totalDiscount.value) || 0;
    let taxValue = Number(totalTax.value) || 0;
    const discDeduct =
      (totalDiscount.type || totalDiscount.valueMethod) === "%"
        ? +subTotalAmt * (discValue / 100)
        : discValue;
    const tot = +(+subTotalAmt - discDeduct).toFixed(2);
    const taxAdd = +(tot * (taxValue / 100)).toFixed(2);
    const val = roundToTwoDecimalPlaces(tot + taxAdd);

    setNetTotalAmt(val || null);
  };

  const handleConvertSign = () => {
    return new Promise((res, rej) => {
      try {
        if (businessSign.type === "text") {
          res(converTextToImage(businessSign.value, "bold 3rem Quente"));
        } else {
          if (businessSign?.value?.startsWith?.("https:/")) {
            res(businessSign?.value);
          } else {
            let reader = new FileReader();
            reader.readAsDataURL(businessSign.value);
            reader.onload = (er) => {
              res(reader.result);
            };
          }
        }
      } catch (error) {
        res("");
      }
    });
  };

  const handleTotalTax = (updatedTax) => {

    let totalTax = updatedTax.value;
    setTotalTax((tx) => ({
      ...tx,
      value: totalTax,
    }));
    //  Log tax change
    // updateNetTotalAmt(subTotalAmt, totalDiscount, updatedTax);
    const newNet = updateNetTotalAmt(subTotalAmt, totalDiscount, updatedTax);
    if (Number(newNet) < Number(receivedAmt?.value || 0)) {
      setReceivedAmt({ edit: false, value: "", paymentMethod: null });
      showSnackbar({ message: I18n.balance_amount_error, severity: "error" });
    }
  };
  const handleTotalDiscount = (updatedDiscount) => {

    let discountVal = updatedDiscount.value;
    setTotalDiscount((tx) => ({
      ...tx,
      value: discountVal,
    }));
    // Log discount change
    const newNet = updateNetTotalAmt(subTotalAmt, updatedDiscount, totalTax);
    if (Number(newNet) < Number(receivedAmt?.value || 0)) {
      setReceivedAmt({ edit: false, value: "", paymentMethod: null });
      showSnackbar({ message: I18n.balance_amount_error, severity: "error" });
    }
  };

  const handleState = (setState = () => { }, payload) => {

    setState(payload);
  };

  const handleEditTransactionItems = async (selectedItems) => {
    let toAdd = [],
      toEdit = [],
      toDelete = [];
    let orderMap = {};
    orders.forEach((x) => {
      orderMap[x.stock.id] = x;
    });

    for (let x of orders) {
      let stock = await x.stock.fetch(); // Fetch stock only once per order
      const matchingItem = selectedItems.find((i) => i.id === x.stock.id);

      if (matchingItem) {
        toEdit.push({
          original: x,
          updated: matchingItem,
        });
            } else {
        toDelete.push({
          original: x,
          updated: stock,
        });
      }
            }
    selectedItems.forEach((x) => {
      if (!orderMap[x.id]) {
        toAdd.push(x);
      }
        });
    // Handle adding new items
    if (toAdd.length) {
      const ordersByItemId = await bulkCreateOrdersV3(business, invoiceDetail, toAdd, type, "invoice");
      await bulkUpdateStockV2(toAdd, type);
      await bulkCreateInventoryV3(business, invoiceDetail, toAdd, type === "out" ? "in" : "out", "invoice", ordersByItemId);
    }

    // Handle editing existing items
    if (toEdit.length) {
      await bulkUpdateTransactionStock(toEdit, type);
      await bulkUpdateInventory(business, invoiceDetail, toEdit, type, "invoice");
      await bulkUpdateOrders(toEdit);
    }

    // Handle deleting items
    if (toDelete.length) {
      await bulkRestoreStock(toDelete, type);
      await bulkDeleteOrders(toDelete);
      await bulkDeleteInventory(invoiceDetail, toDelete, type, "invoice");
    }
    if (selectedItems.length !== orders.length)
      triggerLogEvent(analytics, isSale ? "inv_edit_item" : "pb_edit_item");
  };

  const onSave = async () => {
    if (isLoading) return;
    setIsLoading(true);
    const nextInvoiceCount = Number(business?.invoice_number_count || 0) + 1;

    const isPaidStatus = state.status.toLowerCase() === "paid";
    const pmtType = receivedAmt?.paymentMethod?.type || receivedAmt?.paymentMethod?.value?.toLowerCase?.();
    const pmtName = receivedAmt?.paymentMethod?.label || receivedAmt?.paymentMethod?.name;
    const signatureURI = await handleConvertSign();
    const finalObj = {
      amount: Number(netTotalAmt) || 0,
      invoiceSign: signatureURI,
      method: isPaidStatus
        ? pmtType || "cash"
        : receivedAmt?.value
          ? pmtType || "cash"
          : "",
      bank: pmtType === "bank" ? pmtName || "bank" : "",
      wallet: pmtType === "wallet" ? pmtName || "" : "",
    };


    const invoiceAmountObj = {
      discount: Number(totalDiscount?.value) || 0,
      discount_unit: totalDiscount?.type || "rs",
      tax_rate: Number(totalTax?.value) || 0,
      total: Number(netTotalAmt) || 0,
      sub_total: Number(subTotalAmt) || 0,
      advance_amount: Number(receivedAmt?.value) || 0,
    };
    const isUnPaid = state.status.toLocaleLowerCase() === "unpaid";
    let invoiceStatus = isUnPaid
      ? invoiceAmountObj?.total - Number(invoiceAmountObj?.advance_amount) < 1
        ? "paid"
        : "unpaid"
      : "paid";
    try {
      const filteredItems = ItemList.filter((item) => item.isNew);
      if (filteredItems.length) {
        const updatedList = await Promise.all(
          filteredItems.map(async (item) => {
            const convertedObj = {
              name: item.name,
              stock: 0,
              cost_price: Number(item.cost_price),
              selling_price: Number(item.selling_price),
              unit: "Pieces",
              id: item.id,
            };
            return convertedObj;
          }),
        );
        await bulkStockCreation(updatedList, business);
        triggerLogEvent(
          analytics,
          isSale ? "inv_item_created" : "pb_item_created",
        );
        await Sync(user?.phone_number, navigate);
      }
      let cust = null;
      if (customer?.id) {
        cust = await findCustomerByID(customer?.id);
      }

      let invoiceData = {
        sales_amount: type == "in" ? invoiceAmountObj?.total : 0,
        cost_amount: type == "out" ? invoiceAmountObj?.total : 0,
        amount: invoiceAmountObj?.total,
        date: startDate || new Date(),
        customer: cust,
        image_url: "",
        document_url: "",
        signature: finalObj?.invoiceSign,
        attachment: "",
        note: state.note,
        status: invoiceStatus,
        method: finalObj?.method,
        type,
        tranType: "bill",
        bank: finalObj?.bank,
        wallet: finalObj?.wallet,
        invoice_title: finalObj?.invoiceTitle,
        invoice_number: `${formattedCount(nextInvoiceCount)}`,
        invoice_prefix: isSale ? "INV#" : "PO#",
        due_date: dueDate,
        discount: Number(invoiceAmountObj?.discount) || 0,
        discount_unit: getConvertedDisountMehod(
          invoiceAmountObj?.discount_unit,
        ),
        category: state.category,
        tax_rate: Number(invoiceAmountObj?.tax_rate) || 0,
        total: Number(invoiceAmountObj?.total) || 0,
        sub_total: Number(invoiceAmountObj?.sub_total) || 0,
        advance_amount: isPaidStatus ? Number(invoiceAmountObj?.total) : Number(invoiceAmountObj?.advance_amount) || 0,
        profit: 0,
        partialAmount: 0,
        reference_id: state.po,
      };
      if (isEditFlow) {
        const invoiceTemp = invoice?.length > 0 ? { ...invoice?.[0]._raw } : {};
        invoiceData.invoice_number = invoiceTemp?.invoice_number;
        await handleEditTransactionItems(ItemList);
        await invoice?.[0].updateInvocie(invoiceData);
        let dataForPayment = {
          udhaar_note: invoiceData?.note,
          date: invoiceData?.date || new Date(),
          image_url: null,
          invoice,
          type: "invoicebook",
        };
        if (invoiceData?.amount != invoiceTemp?.amount) {
          dataForPayment["amount"] = invoiceData?.amount;
          let invoicePayment = await getPaymentsByInvoiceExternal(
            invoiceDetail?.id,
            "full_invoice",
          );

          if (invoicePayment.length) {
            await invoicePayment[0]?.updatePayment(dataForPayment);
          } else {
            await customer.createPayment({
              ...dataForPayment,
              uid: uuid(),
              date: new Date(),
              payment_mode: type == "in" ? "Udhaar" : "Jama",
              external_type: "full_invoice",
            });
          }
        }

        const newAdvance = Number(invoiceData?.advance_amount) || 0;
        const oldAdvance = Number(invoiceTemp?.advance_amount) || 0;
        if (newAdvance !== oldAdvance) {
          const partialPayments = await getPaymentsByInvoiceExternal(
            invoiceDetail?.id,
            "partial_invoice",
          );
          if (newAdvance === 0) {
            if (partialPayments.length) {
              await bulkDeletePaymentsV2(partialPayments);
            }
          } else if (partialPayments.length) {
            await partialPayments[0].updatePayment({
              ...dataForPayment,
              amount: newAdvance,
            });
          } else if (cust) {
            await bulkCreatePayments(business, cust, invoiceDetail, [
              {
                ...dataForPayment,
                uid: uuid(),
                amount: newAdvance,
                payment_mode: type === "in" ? "Jama" : "Udhaar",
                external_type: "partial_invoice",
              },
            ]);
          }
          if (cust) {
            const totalOutstanding = await calculateTotalOutstanding(cust);
            await cust.updateTotalOutstanding(totalOutstanding);
          }
        }
        showSnackbar({
          message: `${isSale ? "Invoice" : "Purchase order"} updated`,
          severity: "success",
        });
        Sync(user.phone_number, navigate);
        // setIsLoading(false);

        if (!moment(startDate).isSame(moment(invoiceTemp?.transacted_at)))
          triggerLogEvent(analytics, isSale ? "inv_edit_date" : "pb_edit_date");
        if (invoiceAmountObj.total !== invoiceTemp?.total)
          triggerLogEvent(
            analytics,
            isSale ? "inv_edit_total" : "pb_edit_total",
          );
        if (invoiceAmountObj.discount !== invoiceTemp?.discount)
          triggerLogEvent(
            analytics,
            isSale ? "inv_edit_discount" : "pb_edit_discount",
          );
        if (invoiceAmountObj.tax_rate !== invoiceTemp?.tax_rate)
          triggerLogEvent(analytics, isSale ? "inv_edit_tax" : "pb_edit_tax");
        if (invoiceAmountObj.advance_amount !== invoiceTemp?.advance_amount)
          triggerLogEvent(
            analytics,
            isSale ? "inv_edit_recieved_amount" : "pb_edit_recieved_amount",
          );
        if (finalObj.method !== invoiceTemp?.method)
          triggerLogEvent(
            analytics,
            isSale ? "inv_edit_payment_method" : "pb_edit_payment_method",
          );
        if (finalObj.invoiceSign != invoiceTemp?.signature)
          triggerLogEvent(analytics, isSale ? "inv_edit_sign" : "pb_edit_sign");

        triggerLogEvent(
          analytics,
          isSale ? "inv_edited" : "pb_edited",
          finalObj,
        );
        const editNavPath = location?.state?.pathname
          ? location?.state?.pathname
          : isSale ? "/Sales/SaleInvoice" : "/PurchaseOrders";
        pendingNavRef.current = () => setTimeout(() => navigate(editNavPath, { replace: true }), 200);
        setBypassGuard(true);
      } else {
        invoiceData["id"] = uuid();

        let invoice = await business.createInvoice(invoiceData);
        await business.updateBusinessInvoiceNo(nextInvoiceCount);

        if (ItemList.length) {
          const ordersByItemId = await bulkCreateOrdersV3(
            business,
            invoice,
            ItemList,
            type,
            "invoice",
          );
          await bulkUpdateStockV2(ItemList, type);
          await bulkCreateInventoryV3(business, invoice, ItemList, type === "out" ? "in" : "out", "invoice", ordersByItemId);
        }
        if (cust)
          await handleCreateCustomerPayment(
            business,
            cust,
            invoiceData,
            invoice,
            type,
          );

        // setIsLoading(false);

        if (cust)
          triggerLogEvent(
            analytics,
            isSale ? "inv_customer_added" : "pb_supplier_added",
          );
        if (ItemList.length > 0)
          triggerLogEvent(
            analytics,
            isSale ? "inv_item_added" : "pb_item_added",
          );
        if (startDate)
          triggerLogEvent(analytics, isSale ? "inv_date" : "pb_date");
        if (invoiceAmountObj.total)
          triggerLogEvent(analytics, isSale ? "inv_total" : "pb_total");
        if (invoiceAmountObj.discount)
          triggerLogEvent(analytics, isSale ? "inv_discount" : "pb_discount");
        if (invoiceAmountObj.tax_rate)
          triggerLogEvent(analytics, isSale ? "inv_tax" : "pb_tax");
        if (invoiceAmountObj.advance_amount)
          triggerLogEvent(
            analytics,
            isSale ? "inv_recieved_amount" : "pb_recieved_amount",
          );
        if (finalObj.method)
          triggerLogEvent(
            analytics,
            isSale ? "inv_payment_method" : "pb_payment_method",
          );
        if (finalObj.invoiceSign)
          triggerLogEvent(analytics, isSale ? "inv_sign" : "pb_sign");

        triggerLogEvent(
          analytics,
          isSale ? "inv_created" : "pb_created",
          finalObj,
        );
        const invCount = isSale
          ? await fetchSaleInvoicesCount()
          : await fetchBillInvoicesCount();
        if (invCount === 5) {
          triggerLogEvent(analytics, isSale ? "inv_PU" : "pb_PU");
        }

        await new Promise((r) => setTimeout(r, 0)); // ensure state updates finish
        pendingNavRef.current = () =>
          handleDemoNavigation(
            isSale ? "sales" : "purchase",
            `/TransactionSuccess/${invoiceData.id}`,
            location?.state?.pathname ? { backPath: location.state.pathname } : {},
            200,
          );
        setBypassGuard(true);

        showSnackbar({
          message: `${isSale ? "Invoice" : "Purchase order"} created`,
          severity: "success",
        });

        Sync(user.phone_number, navigate);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };

  const handleCreateCustomerPayment = async (
    business,
    customer,
    data,
    invoice,
    type,
  ) => {
    let payObj = {
      date: data?.date || new Date(),
      note: data?.note || "",
      image_url: data?.image_url || "",
      type: "invoicebook",
    };

    let paymentArr = [
      {
        ...payObj,
        uid: uuid(),
        amount: data.amount,
        payment_mode: type == "in" ? "Udhaar" : "Jama",
        external_type: "full_invoice",
      },
    ];

    if (data?.advance_amount > 0) {
      paymentArr.unshift({
        ...payObj,
        uid: uuid(),
        amount: Number(data.advance_amount),
        payment_mode: type == "in" ? "Jama" : "Udhaar",
        external_type: "partial_invoice",
      });
    }

    await bulkCreatePayments(business, customer, invoice, paymentArr);

    let totalOutstanding = await calculateTotalOutstanding(customer);

    await customer.updateTotalOutstanding(totalOutstanding);
  };
  const handleCreateContact = (name, type) => {
    openCreateCustomerModal(name);
  };
  const openCreateCustomerModal = (value) => {
    if (value?.match?.(phoneNumRegex) === null) {
      setInitname(value);
      setInitphone("");
    } else {
      setInitphone(value);
      setInitname("");
    }
    setCreateCustomerModal(true);
  };

  const handleAddCustomer = (payload) => {
    setCreateCustomerModal(false);
    handleState(setCustomer, {
      id: payload.id,
      label: payload.name,
      labelText: payload.name,
      value: payload.name,
      phone_name: payload?.phone_name
    });
  };
  const handleReceivedAmount = (totalAmt) => {

    if (validatePriceQtyInput(totalAmt, 9999999999)) {
      const result = removeRsFromValue(totalAmt);
      if (result.length >= 1 && receivedAmt.value == 0 && !isEditFlow)
        triggerLogEvent(
          analytics,
          type == "in" ? "inv_recieve_start" : "pb_paid_start",
        );
      const total = netTotalAmt - (result || 0);
      if (total >= 0)
        setReceivedAmt((rcv) => ({
          ...rcv,
          value: result,
        }));
      else {
        setReceivedAmt((rcv) => ({
          ...rcv,
          value: netTotalAmt,
        }));
        showSnackbar({
          message: I18n.balance_amount_error,
          severity: "error",
        });
      }
    }
  };

  const handleUpdateByItem = (items) => {
    if (items) {
      const inv = invoice ? invoice[0] : {};
      const subTot = items?.reduce((prev, curr) => {
        return (
          prev +
          Number(
            isSale
              ? curr?.quantity * curr?.selling_price
              : curr?.quantity * curr?.cost_price,
          )
        );
      }, 0);
      setSubTotalAmt(!subTot && IsAlreadysubTotalAmt ? inv?.sub_total : subTot);
      if (IsAlreadysubTotalAmt) setIsAlreadySubTotalAmt(false);
      if (subTot < totalDiscount.value) {
        setTotalDiscount((x) => ({
          ...x,
          edit: false,
          value: 0,
        }));
        setTotalTax((x) => ({
          ...x,
          edit: false,
          value: 0,
        }));
      }
    }
  };
  const handleAddItem = (items) => {

    setItemList(items);
    handleUpdateByItem(items);
    const result = items.reduce((acc, item) => {
      acc[item.id] = item; // Set the key as item.id and value as the item object
      return acc;
    }, {});
    setItemObj(result);
  };
  const handleActiveWallet = () => {
    pendingNavRef.current = () => setTimeout(() => navigate("/UCash"), 100);
    setBypassGuard(true);
  };


  const handleViewQR = (bool) => {
    setOpen(bool);
  };
  const handleGetQR = () => {
    pendingNavRef.current = () => navigate("/WalletOnboarding");
    setBypassGuard(true);
  };

  const handleAddContact = () => {
    setAddContact(true);
  };
  const handleSendMoney = () => {
    if (!ItemList.length || !customer?.id) {
      showSnackbar({ message: I18n.add_contact_and_items_to_send_money, severity: "error" });
      return;
    }
    if (!netTotalAmt || Number(netTotalAmt) <= 0) {
      showSnackbar({ message: I18n.amount_required_to_send_money, severity: "error" });
      return;
    }


    if (!isEMIVerified) {
      pendingNavRef.current = () => navigate("/WalletOnboarding");
      setBypassGuard(true);
      return;
    }

    const isVerifiedAccountForWallet =
      accountInfo?.emi_onboarding_status === EMIONBOARDINGSTATUS.VERIFIED &&
      accountInfo?.verified === VERIFIED.VERIFIED;

    const destination = isVerifiedAccountForWallet ? "/UCash/SendMoney" : "/WalletOnboarding";

    if (isEditFlow) {
      const invoiceUpdatePayload = {
        mode: "edit_form",
        invoiceId: invoiceDetail.id,
        amountToSend: Number(netTotalAmt) - (invoiceDetail.advance_amount || 0),
        currentAdvanceAmount: invoiceDetail.advance_amount || 0,
        previousAmount: invoiceDetail.amount,
        addedCustomer: Boolean(customerAdded),
        amount: Number(netTotalAmt),
        sales_amount: type === "in" ? Number(netTotalAmt) : 0,
        cost_amount: type === "out" ? Number(netTotalAmt) : 0,
        sub_total: Number(subTotalAmt) || 0,
        discount: Number(totalDiscount?.value) || 0,
        discount_unit: getConvertedDisountMehod(totalDiscount?.type || "rs"),
        tax_rate: Number(totalTax?.value) || 0,
        total: Number(netTotalAmt) || 0,
        note: state.note,
        reference_id: state.po || "",
        category: state.category,
        date: startDate?.toISOString ? startDate.toISOString() : new Date().toISOString(),
        due_date: dueDate || null,
        customerId: customer?.id || null,
        type,
        invoiceType: "invoicebook",
        attachment: "",
        items: ItemList,
        invoice_number: invoiceDetail.invoice_number,
        invoice_prefix: invoiceDetail.invoice_prefix,
        invoice_title: invoiceDetail.invoice_title,
        document_url: invoiceDetail.document_url,
        signature: invoiceDetail.signature,
        tax_title: invoiceDetail.tax_title,
        image_url: invoiceDetail.image_url,
        recording_uri: invoiceDetail.recording,
      };
      pendingNavRef.current = () =>
        navigate(destination, { state: { invoiceUpdatePayload, backPath: "/PurchaseOrders" } });
      setBypassGuard(true);
      return;
    }

    const expensePayload = {
      amount: Number(netTotalAmt) || 0,
      subTotal: Number(subTotalAmt) || 0,
      discount: Number(totalDiscount?.value) || 0,
      discountUnit: totalDiscount?.type || "rs",
      taxRate: Number(totalTax?.value) || 0,
      note: state.note,
      reference_id: state.po || "",
      category: state.category,
      date: startDate?.toISOString ? startDate.toISOString() : new Date().toISOString(),
      due_date: dueDate || null,
      status: state.status,
      customerId: customer?.id || null,
      items: ItemList,
      type,
      files: "",
      isPurchaseOrder: type === "out",
    };

    pendingNavRef.current = () =>
      navigate(destination, { state: { expensePayload, backPath: "/PurchaseOrders" } });
    setBypassGuard(true);
  };
  const isDisabled = !Boolean(ItemList.length && customer);
  const isVerifiedAccountForWallet =
    accountInfo?.emi_onboarding_status === EMIONBOARDINGSTATUS.VERIFIED &&
    accountInfo?.verified === VERIFIED.VERIFIED;

  useEffect(() => {
    const el = document.querySelector(".appLayoutContent");
    if (!el) return undefined;
    const prev = el.style.overflow;
    const mq = window.matchMedia("(min-width: 900px)");
    const sync = () => {
      el.style.overflow = mq.matches ? "hidden" : prev || "";
    };
    sync();
    mq.addEventListener("change", sync);
    return () => {
      mq.removeEventListener("change", sync);
      el.style.overflow = prev;
    };
  }, []);
  let top2Cate = [...categoryList];
  top2Cate = top2Cate.splice(0, 2);
  return isAccountLoading ? (
    <BusinessLoader loadBusiness={isAccountLoading} />
  ) : (
    <Box className={styles.createInvoicePageShell}>
      <Grid container className={styles.splitGrid}>
        <Grid item md={6} className={styles.leftColumn}>
          <Box
            className={`createInvoiceWrapper ${styles.createInvoiceWrapper}`}
          >
            <TitleAndActionBox
              data={{
                id: type === "out" ? "purchase_bill" : "sale_invoice",
                title:
                  type === "out"
                    ? isEditFlow
                      ? "edit_purchase_order"
                      : "create_purchase_order"
                    : isEditFlow
                      ? "edit_sale_invoice"
                      : "create_sale_invoice",
                isBack: true,
              }}
            ></TitleAndActionBox>
            <Box className={styles.leftScroll}>
              {!isNextPage ? (
                <Box className={styles.invoiceFormWrapper}>
                  <Box className={styles.invoiceFormTabWrapper}>
                    <TabAutoComplete
                      id="quick_contactlist"
                      list={contactList}
                      label={I18n.contact}
                      handleSelect={(item) => {
                        setCustomer(item);
                      }}
                      required={true}
                      value={customer?.labelText || ""}
                      handleCreate={handleCreateContact}
                      placeholder={I18n.select_a_contact}
                      disabled={Boolean(customerAdded)}
                      hideCloseIcon={Boolean(customerAdded)}
                      asCreate={I18n?.contact?.toLowerCase()}
                      handleStartLogEvent={
                        isEditFlow
                          ? () => { }
                          : () =>
                            triggerLogEvent(
                              analytics,
                              type == "in"
                                ? "inv_customer_start"
                                : "pb_supplier_start",
                            )
                      }
                      manuallyFocusInput={addContact}
                      handleManuallyInput={() => setAddContact(false)}
                    />
                    <Box className={styles.paymentStatusBoxWrapper}>
                      <Box className={styles.paymentStatusBox}>
                        <Box className={styles.paymentStatusBoxLeft}>
                          <UBRadioBox
                            label={"Paid"}
                            displayLabel={I18n.paid}
                            onChange={(value) => {
                              // setDirty(true);
                              triggerLogEvent(
                                analytics,
                                isSale ? "quick_sale_paid" : "expense_paid",
                                {
                                  type: value,
                                },
                              );
                              setState((preState) => ({
                                ...preState,
                                status: value,
                              }));
                              if (!receivedAmt?.paymentMethod) {
                                const bankMethod = updatedPaymentMethods.find(m => m.name === "bank");
                                setReceivedAmt(e => ({ ...e, paymentMethod: bankMethod || null }));
                              }
                            }}
                            value={state.status}
                          />
                          <UBRadioBox
                            label={"Unpaid"}
                            displayLabel={I18n.unpaid}
                            onChange={(value) => {
                              // setDirty(true);
                              triggerLogEvent(
                                analytics,
                                isSale ? "quick_sale_unpaid" : "expense_unpaid",
                                {
                                  type: value,
                                },
                              );
                              setState((preState) => ({
                                ...preState,
                                status: value,
                              }));
                              setReceivedAmt({
                                edit: false,
                                value: invoiceDetail?.advance_amount || null,
                                paymentMethod: resolvePaymentMethod(invoiceDetail),
                              })
                            }}
                            value={state.status}
                          />
                        </Box>
                        <Box className={styles.paymentStatusBoxRight}>
                          <PaymentMethodToggle
                            visible={
                              state.status.toLocaleLowerCase() === "paid"
                            }
                            value={
                              receivedAmt?.paymentMethod?.name ||
                              receivedAmt?.paymentMethod?.type ||
                              null
                            }
                            onChange={(method) => {
                              setReceivedAmt((e) => ({
                                ...e,
                                paymentMethod: method,
                              }));
                              handleViewQR(false);
                            }}
                          />
                        </Box>
                      </Box>
                      <AppCollectPayment
                        visible={
                          !Boolean(isEditFlow && customerAdded && type == "in") &&
                          state.status.toLocaleLowerCase() !== "Unpaid" &&
                          (receivedAmt?.paymentMethod?.name ||
                            receivedAmt?.paymentMethod?.type ||
                            null) === "bank"
                        }
                        status={state.status}
                        hasRaastDetail={!!isEMIVerified}
                        onViewQR={() => handleViewQR(true)}
                        onGetQR={() => handleGetQR()}
                        onAddContact={
                          isSale || state.status == "Unpaid"
                            ? handleAddContact
                            : handleSendMoney
                        }
                        customMessage={
                          !isSale ? I18n.make_payment_with_bank_transfer : null
                        }
                        customLinkText={!isSale ? I18n.send_money : null}
                        contactValue={customer?.labelText || ""}
                        isSale={isSale}
                      />
                    </Box>
                    <TabAutoComplete
                      id={"category_forP&L_tracking"}
                      list={categoryList}
                      label={I18n.category_pl_tracking}
                      handleSelect={(item) => {
                        setState((e) => ({
                          ...e,
                          category: item?.id || "",
                          categoryLabel: item?.label || "",
                        }));
                      }}
                      value={state.categoryLabel}
                      placeholder={isSale ? I18n.select_sales_category : I18n.select_purchase_category}
                      handleStartLogEvent={
                        isEditFlow
                          ? () => { }
                          : () =>
                            triggerLogEvent(
                              analytics,
                              `${isSale ? "inv" : "pb"}_category_start`,
                            )
                      }
                      handleManuallyInput={() => setCategoryOpen(false)}
                      manuallyFocusInput={categoryOpen}
                    />
                  </Box>

                  <Box className={styles.categoryInputBoxChip}>
                    {top2Cate.length > 1 &&
                      top2Cate.map((item) => (
                        <Chip
                          key={item.label || item.value}
                          className={styles.categoryInputBoxChipItem}
                          onClick={() =>
                            setState((e) => ({
                              ...e,
                              category: item?.id || "",
                              categoryLabel: item?.label || "",
                            }))
                          }
                          label={item.label}
                        />
                      ))}
                    <span
                      onClick={() => setCategoryOpen(true)}
                      className="cursorPointer barclayBlueColor fontSize12 textDecorationUnerline"
                    >
                      {I18n.see_more}
                    </span>
                  </Box>

                  <StockAddItem
                    id="invoice_sale"
                    itemObj={itemObj}
                    handleAddItem={handleAddItem}
                    isITook={type === "out"}
                    required
                    handleStartLogEvent={
                      isEditFlow
                        ? () => { }
                        : () =>
                          triggerLogEvent(
                            analytics,
                            isSale ? "inv_item_start" : "pb_item_start",
                          )
                    }
                    isDisplayUpdateAmountSection={false}
                  />

                  <Box className={styles.seperator}></Box>

                  <NetCalculationCard
                    subTotalAmt={subTotalAmt}
                    totalDiscount={totalDiscount}
                    setTotalDiscount={(paload) =>
                      handleState(setTotalDiscount, paload)
                    }
                    handleTotalDiscount={handleTotalDiscount}
                    totalTax={totalTax}
                    setTotalTax={(paload) => handleState(setTotalTax, paload)}
                    handleTotalTax={handleTotalTax}
                    totalAmount={+subTotalAmt}
                    handleDiscountLogEvent={
                      isEditFlow
                        ? () => { }
                        : () =>
                          triggerLogEvent(
                            analytics,
                            type == "in"
                              ? "inv_discount_start"
                              : "pb_discount_start",
                          )
                    }
                    handleTaxLogEvent={
                      isEditFlow
                        ? () => { }
                        : () =>
                          triggerLogEvent(
                            analytics,
                            type == "in" ? "inv_tax_start" : "pb_tax_start",
                          )
                    }
                    isEditMode={isEditFlow}
                    children={
                      <SelectAmountSummary
                        selectAmountType={type == "out" ? "purchase" : "sale"}
                        pmtMethod={pmtMethod}
                        setPmtMethod={(paload) => setPmtMethod(paload)}
                        setReceivedAmt={(paload) => setReceivedAmt(paload)}
                        receivedAmt={receivedAmt}
                        handleReceivedAmount={handleReceivedAmount}
                        netTotalAmt={netTotalAmt}
                        balanceAmount={balanceAmount}
                        ItemList={state.items}
                        type={type}
                        isRecievedAmountField={
                          state.status.toLocaleLowerCase() === "unpaid"
                        }
                        handlePaymentLogEvent={
                          isEditFlow
                            ? () => { }
                            : () =>
                              triggerLogEvent(
                                analytics,
                                type == "in"
                                  ? "sale_invoice_payment_start"
                                  : "pb_payment_start",
                              )
                        }
                      />
                    }
                  />



                  <UBButton
                    id={isSale ? "save_qucik_sale" : "save_expence"}
                    title={<ParagraphText>{I18n.next} </ParagraphText>}
                    className={"buttonPrimary saveSaleButton"}
                    onClick={() => setNextPage(true)}
                    disabled={isDisabled}
                  />
                </Box>
              ) : (
                <Fragment>
                  <Box className={styles.invoiceFormWrapper}>
                    <Grid container spacing={2}>
                      <Grid item md={6}>
                        <UBInput
                          label={
                            type === "in"
                              ? (I18n.invoice_no || "Invoice number")
                              : (I18n.purchase_no || "Purchase number")
                          }
                          baseClassname="inv_field invoice_number_field hide_spinner"
                          placeholder={getSerailNumber(
                            Number(business?.invoice_number_count || 0) + 1,
                          )}
                          value={`${isSale ? "INV #" : "PO #"}${isEditFlow ? invoice?.[0]?.invoice_number : formattedCount(business.invoice_number_count + 1)}`}
                          inputType="number"
                          onlyNumbers={true}
                          maxLength={6}
                          disabled={true}
                        />
                      </Grid>
                      <Grid item md={6}>
                        <UBInput
                          inputId="create_invoice_reference_number"
                          label={capitalize(I18n.reference_number)}
                          baseClassname="inv_field invoice_number_field hide_spinner"
                          placeholder={`${I18n.enter} ${I18n.reference_number}`}
                          value={state?.po}
                          title=""
                          onChange={(key, value) => {
                            setState((prev) => ({
                              ...prev,
                              po: value,
                            }));
                          }}
                          maxLength={15}
                        />
                      </Grid>
                      <Grid item md={6} className={styles.dueDateBoxWrapper}>
                        <Box className={styles.markAsPaidDateBoxWrapper}>
                          <ParagraphText className="fontSize14 fontWeight400 newFontColor">
                            {type === "in" ? I18n.invoice_date : I18n.purchase_date}
                          </ParagraphText>
                          <UBDateSelect
                            id={type === "in" ? "inv_date" : "pb_date"}
                            selectedDate={startDate}
                            setSelectedDate={(date) => {
                              if (
                                dueDate &&
                                (dayjs(date).isAfter(dueDate) ||
                                  dayjs(date).isSame(dueDate))
                              )
                                setDueDate(null);
                              setStartDate(date);
                            }}
                            title={null}
                            isCalendericon
                            closeOnDateSelect={true}
                            handleLogEvent={
                              isEditFlow
                                ? () => { }
                                : () =>
                                  triggerLogEvent(
                                    analytics,
                                    type === "in"
                                      ? "inv_date_start"
                                      : "pb_date_start",
                                  )
                            }
                          />
                        </Box>
                      </Grid>
                      <Grid item md={6} className={styles.dueDateBoxWrapper}>
                        <Box className={styles.markAsPaidDateBoxWrapper}>
                          <ParagraphText className="fontSize14 fontWeight400 newFontColor">
                            {I18n.due_date}
                          </ParagraphText>

                          <UBDateSelect
                            id={type === "in" ? "inv_due_date" : "pb_due_date"}
                            selectedDate={dueDate}
                            setSelectedDate={setDueDate}
                            title={null}
                            isCalendericon
                            minDate={dayjs(startDate)}
                            closeOnDateSelect={true}
                            placeholder={I18n.select_due_date}
                            handleLogEvent={
                              isEditFlow
                                ? () => { }
                                : () =>
                                  triggerLogEvent(
                                    analytics,
                                    type === "in"
                                      ? "inv_due_date_start"
                                      : "pb_due_date_start",
                                  )
                            }
                          />
                        </Box>
                      </Grid>
                      <Grid item
                        md={12}>
                        <Box className={styles.memoWrapper}>
                          <UBInput
                            inputId={
                              isSale ? "sale_invoice_note" : "purchase_bill_note"
                            }
                            name="note"
                            label={I18n.note}
                            placeholder={I18n.add_notes_here}
                            onChange={onChangeText}
                            value={state.note}
                            multiline
                            rows={1}
                            maxLength={500}
                          />
                        </Box>

                      </Grid>

                      <Grid
                        item
                        md={6}
                        className={`${styles.dueDateBoxWrapper} ${styles.bankCheckboxWrapper}`}
                      >
                        <AppCheckbox
                          disabled={false}
                          label={sentenceCase(I18n.signature)}
                          sublabel={sentenceCase(isSale ? I18n.add_signature_on_invoice : I18n.add_signature_on_purchase_order)}
                          onClick={(e) =>
                            setState((e) => ({
                              ...e,
                              isSignature: !e?.isSignature,
                            }))
                          }
                          checked={state.isSignature}
                        />
                      </Grid>

                      <Grid
                        item
                        md={6}
                        className={styles.signatureSectionWrapper}
                      >
                        {state?.isSignature && (
                          <SignatureSection
                            sign={businessSign}
                            getSignImage={getSignImage}
                            setSign={(paload) =>
                              handleState(setBusinessSign, paload)
                            }
                            type={type}
                            isEditMode={isEditFlow}
                          />
                        )}
                      </Grid>

                      <Box className={styles.buttonWrapper}>
                        <UBButton
                          id={isSale ? "back_sale_invoice" : "back_expence"}
                          title={I18n.back}
                          className={"ubSecondaryButton textUppercase"}
                          onClick={() => setNextPage(false)}
                        />
                        <UBButton
                          id={
                            isSale ? "save_sale_invoice" : "save_purchase_bill"
                          }
                          title={<ParagraphText>{I18n.save} </ParagraphText>}
                          loading={isLoading}
                          iconComponent={<EnterIcon />}
                          iconPlacement="right"
                          disabled={isDisabled || isLoading}
                          onClick={onSave}
                          className={"buttonPrimary saveSaleButton"}
                        />
                      </Box>
                    </Grid>
                  </Box>
                </Fragment>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item md={6} className={styles.previewColumn}>
          <PreviewInvoice
            InvoiceData={{
              BusinessDetails: {
                bImg: business?.image_url,
                bName: business?.name || "",
                bNum: user?.phone_number || "",
                bAdd: business?.address,
              },
              CustomerDetails: {
                cName: customer?.value || "",
                cPhone: customer?.phone_number || "",
                invoiceNum: `${isSale ? "INV#" : "PO#"}${isEditFlow ? invoice[0]?.invoice_number : formattedCount(business?.invoice_number_count + 1)}`,
                date: startDate
                  ? `${dayjs(startDate).format("DD MMM YYYY")}`
                  : "",
                dueDate: dueDate
                  ? `${dayjs(dueDate).format("DD MMM YYYY")}`
                  : "",
              },
              ItemDetails: ItemList?.map((it, ind) => {
                return {
                  name: it?.name,
                  qty: `${it?.quantity}`,
                  unitPrice: isSale ? it?.selling_price : it?.cost_price,
                  price: isSale
                    ? it?.quantity * it?.selling_price
                    : it?.quantity * it?.cost_price,
                };
              }),
              BillDetails: {
                subT: subTotalAmt || 0,
                disc: `${formatDiscount(
                  totalDiscount?.value
                    ? totalDiscount?.type == "rs"
                      ? formatNum(totalDiscount?.value)
                      : totalDiscount?.value
                    : 0,
                  totalDiscount?.type
                    ? totalDiscount?.type == "rs"
                      ? "Rs."
                      : "%"
                    : "Rs.",
                )}`,
                tax: `${totalTax?.value || 0}%`,
                advance: receivedAmt?.value || 0,
                paymentMethod: receivedAmt.paymentMethod || "Cash",
                total: netTotalAmt || 0,
                taxValue: totalTax?.value || 0,
                discValue: totalDiscount?.value || 0,
              },
              Signature: businessSign,
              state,
              accountInfo,
              isVerifiedAccountForWallet,
              documentType: type,
            }}
          />
        </Grid>
      </Grid>
      {open && <PaymentQRCode
        accountInfo={accountInfo}
        isModal={open}
        handleClose={() => setOpen(false)}
      />}
      <AddCustomerModal
        isOpen={createCustomerModal}
        handleClose={(v) => {
          setCreateCustomerModal(false);
        }}
        initialName={initName}
        initialPhone={initPhone}
        onSaveCallback={handleAddCustomer}
        title={
          <ParagraphText className={"ms-1 textLowercase"}>
            {I18n.customer}
          </ParagraphText>
        }
        isTypeField={true}
        className={"customer-selector-create-modal"}
        isBothTypeContact={true}
      />
      <RouteLeavingGuard
        when={isFormDirty}
        confirmText={isSale ? I18n.discard_invoice_btn : I18n.discard_bill_btn}
        title={isSale ? I18n.discard_invoice_title : I18n.discard_bill_title}
        handleConfirm={() =>
          triggerLogEvent(analytics, isSale ? "inv_discard" : "pb_discard")
        }
      />
      <WalletNonidealModal
        isPending={false}
        setOpen={setWalletNonidealModal}
        open={walletNonidealModal}
        raastDetail={null}
        applicationID={null}
        isVerificationFailed={null}
      />
    </Box>
  );
};

const enhance = withObservables([], ({ navigate, location, business }) => {
  const phoneNum = localStorage.getItem("phone_number");
  if (
    location?.pathname?.includes?.("Edit") &&
    (!location?.state?.data || !location?.state?.pathname)
  ) {
    navigate(-1);
  }
  const defaultObservers = {
    addresses: observeAddressByPhoneNumber(phoneNum),
    customers: business ? business?.getAllCustomers.observe() : of([]),
  };
  const modifiedObservers = {
    ...defaultObservers,
  };
  const invoiceId = location?.state?.data?.invoiceId;
  if (location?.pathname?.includes?.("Edit") && invoiceId) {
    const custId = location?.state?.data?.customerId;
    modifiedObservers.invoice = observeCurrentInvoice(invoiceId);
    modifiedObservers.orders = observeOrdersByInvoiceID(invoiceId);
    if (custId) {
      modifiedObservers.invCustomer = getCustomerByID(custId);
    }
  }
  return modifiedObservers;
});

export default enhance(CreateInvoice);
